export const ADMIN_PLAYER_LINEUP_TYPES = [
    'STARTING_LINEUP',
    'SUBSTITUTES',
    'NOT_IN_LINEUP',
    'COACH'
] as const;

export type AdminPlayerLineupType = typeof ADMIN_PLAYER_LINEUP_TYPES[number];

export interface AdminMatchTeamInfoDto {
    id: number;
    name?: string | null;
    photo_url?: string | null;
}

export interface AdminMatchTeamOptionDto {
    syncId: string;
    teamInfo: AdminMatchTeamInfoDto;
}

export interface AdminMatchPlayerInfoDto {
    id: string;
    teamId?: string | null;
    name: string;
    nameTranslations?: Record<string, string> | null;
    imgUrl?: string | null;
    teamInfo?: AdminMatchTeamInfoDto | null;
    lineupType?: AdminPlayerLineupType | null;
    hasPlaytime: boolean;
}

export interface AdminMatchEventHistoryDto {
    minute: number;
    type?: string | null;
    playerId?: string | null;
    playerInfo?: AdminMatchPlayerInfoDto | null;
    assistantId?: string | null;
}

export interface AdminMatchStatItemDto {
    type?: string | null;
    unitType?: string | null;
    homeStat?: number | null;
    awayStat?: number | null;
}

export default interface AdminMatchStatDto {
    varietyId: number;
    matchId: number;
    varietyName: string;
    providerEventId?: string | null;
    providerSource?: string | null;
    updatedAt?: string | null;
    stats: AdminMatchStatItemDto[];
    playersInfo: AdminMatchPlayerInfoDto[];
    eventHistory: AdminMatchEventHistoryDto[];
}

export interface AdminMatchPlayersDto {
    varietyId: number;
    matchId: number;
    varietyName: string;
    providerEventId?: string | null;
    providerSource?: string | null;
    updatedAt?: string | null;
    playersInfo: AdminMatchPlayerInfoDto[];
    availableTeams: AdminMatchTeamOptionDto[];
}

export interface AdminMatchHistoryDto {
    varietyId: number;
    matchId: number;
    varietyName: string;
    providerEventId?: string | null;
    providerSource?: string | null;
    updatedAt?: string | null;
    eventHistory: AdminMatchEventHistoryDto[];
}
